import React from 'react';
import ButtonSeplag from '../../../../components/buttonSeplag/ButtonSeplag';
import { useHistory } from 'react-router-dom';
import Pages from '../../../../config/Pages';
import PageMessages from '../../../../config/translations/PageMessages';

export default function AfterActionsButtons({ dados, confirmRef }) {
    const history = useHistory();

    return (
        <ButtonSeplag
            tipo="warning"
            type="button"
            tooltip="Analisar Solicitação"
            tooltipOptions={{ position: 'top' }}
            icon="pi pi-file-edit"
            style={{ marginLeft: '5px' }}
            onClick={() => {
                if (dados?.meta?.indicador?.situacaoIndicador?.codgSituacaoIndicador === 'ATIVO') {
                    history.push(Pages.sei.analisePropostaMeta.url.edit.replace(':id', dados.id));
                } else {
                    confirmRef.current.show(PageMessages.sei.analisePropostaMeta.indicadorNaoAtivo);
                }
            }}
        />
    );
}
